import { type BoxProps, type ButtonProps, Box, Button } from "~/foundation/Chakra";
import { motion } from "framer-motion";

type MotionBoxTypes = Omit<BoxProps, "transition">;
type MotionButtonTypes = Omit<ButtonProps, "transition">;

export const MotionBox = motion<MotionBoxTypes>(Box);
export const MotionButton = motion<MotionButtonTypes>(Button);
